
<div class="container-fluidX my-3">
  <div class="calc-windowX">
    
    <!-- Window Title Bar -->
    <!-- <div class="calc-titlebar">
      <div class="calc-title">
        <span class="calc-icon"></span>
        <span>Calculator</span>
      </div>
      <div class="win-controls">
        <span>&minus;</span>
        <span>&#9633;</span>
        <span class="close-btn" onclick="window.close();">&times;</span>
      </div>
    </div> -->

    <!-- Main Workspace Frame -->
    <div class="calc-body">
      
      <!-- Left: Dynamic Statement Ledger -->
      <div class="ledger-container">
        <div class="ledger-rows" id="ledgerRows">
          <!-- Static calculation lines appended dynamically here -->
        </div>

        <!-- Sticky inputs & highlights at bottom container -->
        <div class="mt-auto">
          <!-- Live Result Row -->
          <div class="ledger-row ledger-result-row">
            <div class="ledger-op">=</div>
            <div class="ledger-val" id="ledgerLiveTotal">0.00</div>
          </div>
          <!-- Decorative Blue Active Status Bar -->
          <div class="ledger-spacer-blue"></div>
          
          <!-- Bottom Entry Processing Row -->
          <div class="ledger-input-row">
            <div class="ledger-op" id="nextOperator">+</div>
            <div class="position-relative flex-grow-1">
              <input type="text" id="calcInput" placeholder="0.00" autocomplete="off"
                [(ngModel)]="calcInput" (keydown)="calcInput_keydown($event)">
            </div>
          </div>
        </div>
      </div>

      <!-- Right: Action Triggers & Info Blocks -->
      <div class="controls-sidebar">
        <button class="btn btn-sm btn-light" id="btnCalculate" (click)="calculate_click()">Calculate</button>
        <button class="btn btn-sm btn-light" id="btnClear" (click)="clear_click()">Clear Screen</button>
        <button class="btn btn-sm btn-light" id="btnSave" (click)="save_click()"><u>S</u>ave</button>
        <button class="btn btn-sm btn-light" id="btnRestore" (click)="restore_click()">Res<u>t</u>re</button>
        <!-- <button class="btn btn-sm btn-light" id="btnClose" onclick="alert('Close requested');"><u>C</u>lose</button> -->

        <!-- Precision Setup -->
        <div class="sidebar-block d-flex justify-content-between mt-5">
          <div class="block-title">Round All<br>Nos To</div>
          <div class="block-input-wrap">
            <input type="number" id="roundPrecision" value="2" min="0" max="6" (change)="renderLedger()">
          </div>
        </div>

        <!-- Grand Total Aggregate View -->
        <div>
          <div class="display-box-title">Grand Total</div>
          <div class="display-box" id="boxGrandTotal">0.00</div>
        </div>

        <!-- Last Position Sync Row View -->
        <div>
          <div class="display-box-title">Result at Last Row</div>
          <div class="display-box" id="boxLastRowTotal">0.00</div>
        </div>
      </div>

    </div>

    <!-- Bottom Context Info Bar -->
    <div class="calc-statusbar">
      NOTE: Put your value and press either Enter key or Calculate button.
    </div>

  </div>
</div>

